import type { DisplayPointOfSaleInfos_PointOfSaleFragment } from '@gql-generated/graphql'
import moment from 'moment'
import { mapStringOpeningHourToMoment } from './pointOfSale.mapping'

const BRAND = process.env.NEXT_PUBLIC_BRAND

export function formatOpeningHourIntervalPart({
  dayOfWeek,
  stringHour,
}: {
  dayOfWeek: number
  stringHour: string
}): string {
  return mapStringOpeningHourToMoment({ dayOfWeek, stringHour }).format('HH[h]mm')
}

export function formatExceptionalDate(date: string) {
  return moment(date).format('dddd DD MMMM YYYY')
}

export function buildGoogleMapsRequest(
  pointOfSale: StrictPick<
    DisplayPointOfSaleInfos_PointOfSaleFragment,
    'address' | 'name' | 'subsidiary'
  >,
) {
  const { line1, line2, line3, postalCode, city, isoCountryCode } = pointOfSale.address
  const addressParts = [line1, line2, line3, postalCode, city, isoCountryCode].filter(Boolean)

  const searchString =
    `${BRAND?.toUpperCase()} ${pointOfSale?.subsidiary?.name} ${pointOfSale.name} ${addressParts.join(' ')}`
      .replace(/\s+/g, ' ')
      .trim()

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(searchString)}`
}
